import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect}  from 'react-redux';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import ExtraJudicialMatters from './extraJudicialMatters'
import JudicialMatters from './judicialMatters'
import { style } from './formStyle'


import {
    changedMatterValue,
    changedClientOrSubjectOfMatter,
    changedNumberOfClients,
    changedNumberOfOpponents,
    changedValueAddedTax,
} from '../../actions/index.js';

class FeeForm extends Component {
    constructor(props) {
        super(props);
        //this.state = {value: ''};
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const name = event.target.name;
        //console.log(name)
        //console.log(event.target.value)
        //this.setState({value: event.target.value});

        //call action to change values
        console.log(event.target.name)
        switch (name) {
            case 'matterValue':
                let matterValue = event.target.value;
                this.props.changedMatterValue(matterValue)
                break;
            case 'clientOrSubjectOfMatter':
                console.log(event.target.value)
                this.props.changedClientOrSubjectOfMatter(event.target.value)
                break;
            case 'numberOfClients':
                console.log(event.target.value)
                this.props.changedNumberOfClients(event.target.value)
                break;
            case 'numberOfOponents':
                console.log(event.target.value)
                this.props.changedNumberOfOpponents(event.target.value)
                break;
            case 'valueAddedTax':
                console.log(event.target.value)
                this.props.changedValueAddedTax(event.target.value)
                break;
            case 'extraJudicialVV2300':
                console.log(event.target.value)
                this.props.changedExtraJudicialVV(event.target.value, 'VV2300')
                break;
            case 'extraJudicialVV1008':
                console.log(event.target.value)
                this.props.changedExtraJudicialVV(event.target.value, 'VV1008')
                break;
            case 'extraJudicialVV1000':
                console.log(event.target.value)
                this.props.changedExtraJudicialVV(event.target.value, 'VV1000')
                break;

        }

    }

    handleSubmit(event) {
        alert('A name was submitted: ' + this.state.value);
        event.preventDefault();
    }

    render() {
        return (


            <div onSubmit={this.handleSubmit} style={style.form}>
                <Paper zDepth={1} style={style.paper}>
                        <TextField type="number"
                                   name="matterValue"
                                   onChange={this.handleChange}
                                   floatingLabelText="Gegenstandswert"
                                   floatingLabelFixed = {true}
                                   floatingLabelStyle={style.inputFloatingLabelStyle}
                                   floatingLabelFocusStyle={style.inputfloatingLabelFocusStyle}
                                   underlineStyle={style.inputUnderlineStyle}
                                   style={style.input}
                                   inputStyle={style.inputInputStyle}
                                   autoFocus={true}
                                   />

                        <TextField type="number"
                                   name="valueAddedTax"
                                   hintText="U-St."
                                   floatingLabelText="MwSt."
                                   floatingLabelFixed = {true}
                                   floatingLabelStyle={style.inputFloatingLabelStyle}
                                   floatingLabelFocusStyle={style.inputfloatingLabelFocusStyle}
                                   underlineStyle={style.inputUnderlineStyle}
                                   inputStyle={style.inputInputStyle}
                                   value={this.props.feeCalculation.valueAddedTax}
                                   onChange={this.handleChange}
                                   style={style.narrowInput}
                                   />
                      {/*  <br/>

                      }  <TextField type="text"
                                   name="clientOrSubjectOfMatter"
                                   hintText="oder Mandant"
                                   floatingLabelText="Gegenstand"
                                   value={this.props.feeCalculation.clientOrSubjectOfMatter}
                                   onChange={this.handleChange}
                                   style={style.input}
                        /> */}
                        <TextField type="number"
                                   name="numberOfClients"
                                   floatingLabelText="Mandant(en)"
                                   value={this.props.feeCalculation.numberOfClients}
                                   onChange={this.handleChange}
                                   style={style.narrowInput}
                                   floatingLabelStyle={style.inputFloatingLabelStyle}
                                   floatingLabelFocusStyle={style.inputfloatingLabelFocusStyle}
                                   underlineStyle={style.inputUnderlineStyle}
                                   inputStyle={style.inputInputStyle}
                                   value={this.props.feeCalculation.numberOfClients}

                                   />
                   <br/>


                <br/>
                <ExtraJudicialMatters/>
                <JudicialMatters/>
                      </Paper>

            </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        feeTable: state.feeTable,
        feeMatters: state.feeMatters,
        feeCalculation: state.feeCalculation

    };
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        changedMatterValue: changedMatterValue,
        changedClientOrSubjectOfMatter: changedClientOrSubjectOfMatter,
        changedNumberOfClients: changedNumberOfClients,
        changedNumberOfOpponents: changedNumberOfOpponents,
        changedValueAddedTax: changedValueAddedTax,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(FeeForm);



// WEBPACK FOOTER //
// ./src/containers/form/feeForm.jsx